// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"228":"0ca501c013482175","549":"f1f6a18bf215cfce","674":"5d46dcfc0852e869","808":"9a68518c3f632560"}[chunkId] + ".js";
};